import { Controller } from "@hotwired/stimulus";
import React from "react";
import * as ReactDOMClient from "react-dom/client";
import CompanyForm from "../components/CompanyForm";
import { IntlProvider } from "react-intl";
import ReactDOM from "react-dom";
import flattenMessages from "../utils/flattenMessages";

export default class extends Controller {
  get props() {
    return JSON.parse(this.data.get("props") ?? "");
  }

  disconnect() {
    ReactDOM.unmountComponentAtNode(this.element);
  }

  initialize() {}

  connect() {
    const messages = flattenMessages((window as any).jsTranslations || {});
    window.onload = () => {
      const root = ReactDOMClient.createRoot(this.element);

      const locale = this.props.locale;

      root.render(
        <IntlProvider locale={locale} messages={messages}>
          <CompanyForm {...this.props} />
        </IntlProvider>
      );
    };
  }
}
